import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import "./SubHeader.css";

const SubHeader = ({ role }) => {
  return (
    <div className="subHeader">
    
      <Typography variant="subtitle1" component="p" fontWeight="fontWeightBold" fontSize={22} color="secondary">
        Make sure you have your ID Card. If you don't, generate one.
      </Typography>

      <Typography variant="body1" component="p" paddingTop={1}>
        Please provide your details and upload a photo in portrait resolution.
      </Typography>
      {
        role === "admin" &&
        <Box mt={1.25}>
          <Typography variant="body1" component="p" color="error">
            You are logged in as an admin!
          </Typography>
        </Box>
      }
    </div>
  )
}

export default SubHeader;
